import stepSizes from "./stepSizes";

/** Sections of the full tour, in running order. */
export const tourSections = [
	"basics",
	"stories",
	"formatting",
	"links",
	"images",
	"charts",
	"publishing",
	"split",
	"grid",
	"fx",
] as const;

export type TourSection = (typeof tourSections)[number];

export function isTourSection(value: string): value is TourSection {
	return (tourSections as readonly string[]).includes(value);
}

/** First step index of a section — sections run in order, so each
 *  starts where the sizes of everything before it end. */
export function tourSectionStartStep(section: TourSection): number {
	const sizes = stepSizes();
	const before: number[] = [sizes.intro];
	for (const s of tourSections) {
		if (s === section) break;
		before.push(sizes[s]);
	}
	return before.reduce((sum, n) => sum + n, 0);
}
